import { useParams, useSearchParams } from 'react-router-dom'
import MultiViewPanel from '@/components/viewers/MultiViewPanel'

const MultiViewPage: React.FC = () => {
  const { imageId } = useParams<{ imageId: string }>()
  const [searchParams] = useSearchParams()
  const caseId = searchParams.get('caseId')

  const handleClose = () => {
    // Close the tab or go back to previous page
    window.close()
  }

  if (!imageId) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-xl">No image ID provided</div>
      </div>
    )
  }

  return (
    <div className="w-full h-screen bg-black overflow-hidden">
      <MultiViewPanel
        currentImageId={imageId}
        caseId={caseId || undefined}
        onClose={handleClose}
      />
    </div>
  )
}

export default MultiViewPage
